import React, { useState, useEffect }  from 'react';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import { applyPolyfills, defineCustomElements } from '@revolist/revogrid/loader';

const Spreadsheet = props => {
  const {
    columns,
    rows,
    handleChangeData,
    handleSelectCell,
    disabled
  } = props;
  
  const handleBeforeEditStart = (eventData) => {
    if(eventData.detail && eventData.detail.model && eventData.detail.prop) {
      if(eventData.detail.model[eventData.detail.prop+ "_rest"]) {
        eventData.preventDefault();
      }
    }
  };
  
  const handleBeforeRangeEdit = (eventData) => {
    if(disabled) {
      eventData.preventDefault();
    }
    else {
      handleChangeData(eventData);
    }
  };
  
  useEffect(() => {
    defineCustomElements();
    let grid = document.querySelector('revo-grid');
    grid.addEventListener('beforeedit', handleChangeData);
    grid.addEventListener('beforerangeedit', handleBeforeRangeEdit);
    grid.addEventListener('beforecellfocus', handleSelectCell);  
    grid.addEventListener('beforefocuslost', handleSelectCell);
    grid.addEventListener('beforeeditstart', handleBeforeEditStart);
    return () => {
      grid.removeEventListener('beforeedit', handleChangeData);
      grid.removeEventListener('beforerangeedit', handleBeforeRangeEdit);
      grid.removeEventListener('beforecellfocus', handleSelectCell); 
      grid.removeEventListener('beforefocuslost', handleSelectCell);
      grid.removeEventListener('beforeeditstart', handleBeforeEditStart);
    }
  }, []);

  useEffect(() => {
    let grid = document.querySelector('revo-grid');
    grid.columns = columns.map(column_item => {
      return {
        ...column_item,
        cellTemplate: (createElement, props) => {
          if(!props.model[props.prop + "_rest"]) {
            return createElement('span', {}, props.model[props.prop]);
          }
          else {
            return createElement('span', {
              class: {
                "blocked": true
              }
            }, props.model[props.prop]);
          }
        }
      }
    });
    grid.source = rows;
  }, [columns, rows]);
  
  return (
    <revo-grid
      readonly={disabled}
      range={true}
      resize={true}
      class="spreadsheet-component"
      stretch={false}
      theme="compact"
      row-size="28px"
      row-class="myRowClass"
    />
  );
};

export default Spreadsheet;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/spreadsheet.jsx